// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const SplitScreenOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 32 32","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M15 4h2v24h-2zm-5 3v18H4V7h6m0-2H4a2 2 0 00-2 2v18a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zm18 2v18h-6V7h6m0-2h-6a2 2 0 00-2 2v18a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z"}},{"tag":"path","attrs":{"d":"M0 0h32v32H0z","fill":"none"}}]},"name":"split_screen","theme":"outlined"};

const SplitScreenOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={SplitScreenOutlinedSvg} />;
  SplitScreenOutlined.displayName = 'SplitScreenOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(SplitScreenOutlined);
